import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import EmailPulseDataGrid from '../../email-pulse-data-grid/email-pulse-data-grid.component';
import {
  getGiftCardsDataGridColumns,
  giftCardsColumnVisibilityModel,
} from '../gift-cards.config';
import { EmailPulseExportMutationHook } from '../../email-pulse.types';

type GiftCardsDataGridProps = {
  'data-testid': string;
  queryName: string;
  useExportMutation: EmailPulseExportMutationHook;
};

/**
 * Gift Cards tab data grid component.
 * Wrapper around the generic EmailPulseDataGrid with Gift Cards-specific configuration.
 */
const GiftCardsDataGrid = ({
  queryName,
  useExportMutation,
  ...rest
}: GiftCardsDataGridProps) => {
  const { t } = useTranslation();

  const columns = useMemo(() => getGiftCardsDataGridColumns(t), [t]);

  return (
    <EmailPulseDataGrid
      columns={columns}
      columnVisibilityModel={giftCardsColumnVisibilityModel}
      exportFileType="GIFT_CARDS"
      queryName={queryName}
      useExportMutation={useExportMutation}
      pinnedLeftColumn="title"
      {...rest}
    />
  );
};

export default GiftCardsDataGrid;
